import { render, staticRenderFns } from "./FunctionalTestsBlock.vue?vue&type=template&id=6e4056cb&lang=pug&"
import script from "./FunctionalTestsBlock.vue?vue&type=script&lang=js&"
export * from "./FunctionalTestsBlock.vue?vue&type=script&lang=js&"
import style0 from "./FunctionalTestsBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports